//记得在 src\components\lang\zhLoad.js 里面添加对象
const paymentConfirmation = {
};
export default paymentConfirmation



// WEBPACK FOOTER //
// ./src/page/bd/run/collectionConfirm/lang/collectionConfirm.zh.js